import { Button } from '@insurancemenu/imenu-components-lib';
import { boxShadows, colors } from '@insurancemenu/imenu-components-lib/dist/utils';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const TaskStyled = styled.li`
  display: flex;
  flex-direction: column;
  padding: 2rem 3.2rem;
  border-radius: 10px;
  box-shadow: ${boxShadows.light[4]};
  color: ${colors.neutral[900]};
  background-color: ${colors.neutral.white};
`;

export const TaskBodyStyled = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;

  ${breakpointsMQ4.md.down} {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
`;

export const TaskTitleWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid ${colors.neutral[300]};
`;
export const TaskTitleStyled = styled.h3`
  font-size: 2rem;
  line-height: 2.8rem;
  letter-spacing: 0.45px;
  word-break: break-word;
  margin: 0;
`;

export const TaskDescriptionKeyStyled = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-weight: 700;
  color: ${colors.neutral[500]};
  margin: 0 0 0.5rem;
`;

export const TaskDescriptionValueStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0.32px;
  margin: 0;
`;

export const ButtonStyled = styled(Button)`
  /* TODO: Consider adding an additional breakpoint, as 500px is used here and in the library (SubscriberCard).
 * If this value is reused elsewhere, add it to the shared breakpoints object.
 */
  @media (width <= 500px) {
    width: 100%;
  }
`;
